import { Fragment } from 'react'
import React from 'react'

import { Box, Divider, Flex } from '@chakra-ui/react'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import { ItList } from 'types/graphql'

import Icon from 'src/components/widgets/Icon/Icon'
import { BrandColor } from 'src/types'

const Notes = ({
  itList,
  brandColor,
  locked,
  isPreview,
}: {
  itList: ItList
  brandColor: BrandColor
  locked: boolean
  isPreview: boolean
}) => {
  if (!locked || !itList.notes?.length) return null
  return (
    <Box
      px={{ base: 4, lg: isPreview ? 4 : 24 }}
      mt={12}
      id="it-list-item-notes"
    >
      <Box as="h4" className="thick" mb={6}>
        Who this helps
      </Box>
      <Divider color="vapor" />

      {itList.notes.map((note, i) => (
        <Fragment key={`EditItListPreview - Notes - ${i}`}>
          <Flex
            alignItems="center"
            color="stone"
            className="body-small"
            fontSize="1.6rem"
            my={4}
            pl={1}
            wordBreak="break-word"
            data-testid="notes-help"
          >
            <Icon
              icon={faCircleCheck}
              color={brandColor}
              mr={4}
              fontSize={18}
            />
            {note.value}
          </Flex>
          <Divider color="vapor" />
        </Fragment>
      ))}
    </Box>
  )
}

export default Notes
